export type ApiEndpointGroup = 'submissionsRead' | 'submissionsWrite' | 'taxonomyRead' | 'uploadsWrite' | 'chunksWrite' | 'chunksRead'

export interface ApiRoutingConfig {
  apiBaseUrl: string
  tusEndpoint: string
}

export function resolveApiRoutingConfig(
  env: Record<string, string | undefined>,
): ApiRoutingConfig {
  const rawApiBase = (
    env.VITE_PYTHON_API_URL ||
    env.VITE_API_URL ||
    'https://api.vsai-app.com'
  ).replace(/\/+$/, '')

  const tusEndpoint = (
    env.VITE_TUS_ENDPOINT ||
    `${rawApiBase}/tus/`
  ).replace(/\/*$/, '/')

  return {
    apiBaseUrl: rawApiBase,
    tusEndpoint,
  }
}

const runtimeEnv = import.meta.env as unknown as Record<string, string | undefined>
export const apiRoutingConfig = resolveApiRoutingConfig(runtimeEnv)

export function getApiBaseUrl(config: ApiRoutingConfig = apiRoutingConfig): string {
  return config.apiBaseUrl
}

export function getSubmissionsPath(): string {
  return '/v1/submissions'
}

export function getMeSubmissionsPath(): string {
  return '/v1/me/submissions'
}

export function getTaxonomyPath(): string {
  return '/v1/taxonomy'
}

export function getUploadsPath(): string {
  return '/v1/uploads'
}

export function getChunksPath(): string {
  return '/v1/chunks'
}

export function getTusEndpoint(config: ApiRoutingConfig = apiRoutingConfig): string {
  return config.tusEndpoint
}

export function getAbsoluteEndpoint(
  _group: ApiEndpointGroup,
  pathResolver: () => string,
  config: ApiRoutingConfig = apiRoutingConfig,
): string {
  return `${getApiBaseUrl(config)}${pathResolver()}`
}
